import { ArrowRight, Headphones, ScanLine, UserRound } from 'lucide-react';
import { useGame } from '../game/GameContext';
import { BrandMark } from './BrandMark';

export function TitleScreen() {
  const { state, dispatch } = useGame();
  const openCase = () => dispatch({ type: state.profile.created ? 'START_CASE' : 'OPEN_PROFILE' });
  return (
    <main className="title-screen screen-layer">
      <img className="title-screen__art" src={`${import.meta.env.BASE_URL}assets/courtroom-hero.png`} alt="Lyra Vale inside the Tribunal of Echoes" />
      <div className="title-screen__veil" />
      <header className="title-screen__header">
        <BrandMark />
        <div className="title-screen__identity">
          {state.profile.created && (
            <button onClick={() => dispatch({ type: 'OPEN_PROFILE' })}>
              <UserRound />
              <span>{state.profile.callsign}</span>
              <small>LVL {state.profile.level.toString().padStart(2, '0')}</small>
            </button>
          )}
          <span className="case-stamp">CASE FILE / 001</span>
        </div>
      </header>
      <section className="title-screen__copy">
        <p className="eyebrow"><ScanLine size={14} /> Tribunal record reconstructed</p>
        <h1>Every memory<br /><em>leaves an echo.</em></h1>
        <p className="title-screen__lede">
          Defend an accused synthetic mind. Walk the scene. Break the testimony.
          Reconstruct what the court was never meant to see.
        </p>
        <button className="primary-action primary-action--large" onClick={openCase}>
          <span>{state.profile.created ? 'Open the case' : 'Create counsel & begin'}</span><ArrowRight size={19} />
        </button>
        <div className="title-screen__note"><Headphones size={15} /> Headphones recommended · Keyboard + mouse</div>
      </section>
      <footer className="title-screen__footer">
        <span>A deterministic mystery powered by Yuragi Engine</span>
        <span>MOVE W A S D&nbsp;&nbsp;·&nbsp;&nbsp;LOOK MOUSE&nbsp;&nbsp;·&nbsp;&nbsp;INTERACT E</span>
      </footer>
    </main>
  );
}
